import React, { useState } from 'react';
import {
  Button, FormControl, InputLabel, MenuItem, Select, Radio, RadioGroup,
  FormControlLabel, FormLabel, Typography, Box
} from '@mui/material';

// Sample questions for different subjects
const questionsData = {
  Math: [
    { question: "What is 2 + 2?", options: ["3", "4", "5"], correct: "4" },
    { question: "What is 10 / 2?", options: ["3", "4", "5"], correct: "5" }
  ],
  Science: [
    { question: "What is the chemical symbol for water?", options: ["O2", "H2O", "CO2"], correct: "H2O" },
    { question: "What planet is known as the Red Planet?", options: ["Earth", "Mars", "Jupiter"], correct: "Mars" }
  ],
  English: [
    { question: "Which of these is a synonym of 'Happy'?", options: ["Sad", "Joyful", "Angry"], correct: "Joyful" },
    { question: "What is the antonym of 'Fast'?", options: ["Quick", "Slow", "Rapid"], correct: "Slow" }
  ]
};

const MockTest = () => {
  const [selectedSubject, setSelectedSubject] = useState('');
  const [questions, setQuestions] = useState([]);
  const [isTestStarted, setIsTestStarted] = useState(false);
  const [answers, setAnswers] = useState({});
  const [score, setScore] = useState(null);

  // Handle subject selection
  const handleSubjectChange = (e) => {
    setSelectedSubject(e.target.value);
  };

  // Start the mock test
  const startTest = () => {
    if (selectedSubject) {
      setQuestions(questionsData[selectedSubject]);
      setIsTestStarted(true);
      setAnswers({});
      setScore(null);
    }
  };

  // Handle answer selection
  const handleAnswerChange = (questionIndex, selectedOption) => {
    setAnswers({ ...answers, [questionIndex]: selectedOption });
  };

  // Submit the test and calculate the score
  const submitTest = () => {
    let calculatedScore = 0;
    questions.forEach((question, index) => {
      if (answers[index] === question.correct) {
        calculatedScore += 1;
      }
    });
    setScore(calculatedScore);
  };

  return (
    <Box sx={{ padding: '20px' }}>
      <Typography variant="h4" gutterBottom>
        Select subject for test
      </Typography>

      {/* Subject Selection */}
      {!isTestStarted && (
        <Box>
          <FormControl fullWidth sx={{ marginBottom: '20px' }}>
            <InputLabel id="subject-select-label">Select Subject</InputLabel>
            <Select
              labelId="subject-select-label"
              value={selectedSubject}
              onChange={handleSubjectChange}
              label="Select Subject"
            >
              {Object.keys(questionsData).map((subject) => (
                <MenuItem key={subject} value={subject}>
                  {subject}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="contained"
            color="primary"
            onClick={startTest}
            disabled={!selectedSubject}
          >
            Start Test
          </Button>
        </Box>
      )}

      {/* Test Questions */}
      {isTestStarted && (
        <Box>
          <Typography variant="h5" gutterBottom>
            {selectedSubject} Test
          </Typography>
          {questions.map((question, index) => (
            <Box key={index} sx={{ marginBottom: '20px' }}>
              <FormLabel component="legend">{index + 1}. {question.question}</FormLabel>
              <RadioGroup
                row
                name={`question-${index}`}
                value={answers[index] || ''}
                onChange={(e) => handleAnswerChange(index, e.target.value)}
              >
                {question.options.map((option, optionIndex) => (
                  <FormControlLabel
                    key={optionIndex}
                    value={option}
                    control={<Radio />}
                    label={option}
                  />
                ))}
              </RadioGroup>
            </Box>
          ))}
          <Button
            variant="contained"
            color="secondary"
            onClick={submitTest}
            sx={{ marginTop: '20px' }}
          >
            Submit Test
          </Button>
        </Box>
      )}

      {/* Score Display */}
      {score !== null && (
        <Box sx={{ marginTop: '20px' }}>
          <Typography variant="h6">
            Your Score: {score}/{questions.length}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default MockTest;
